<form [formGroup]="dynamicFormGroup" class="d-flex flex-column">
    @for (field of dynamicFields; let fieldIndex = $index; track fieldIndex) {
        <div class="d-flex w-100">
            <app-field-input class="my-1 w-100" [field]="field" />
        </div>
    }
</form>
